import { DIC } from '@/const/dic';

export const safetyGuardAgentOption = {
  align: 'center',
  menuAlign: 'center',
  headerAlign: 'center',
  border: true,
  expand: false,
  stripe: false,
  index: false,
  selection: true,
  menu: true,
  page: true,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  viewBtn: false,
  menuWidth: 360,
  labelWidth: 180,
  defaultSort: {
    prop: 'createTime',
    order: 'descending'
  },
  column: [
    {
      label: '代理商编码',
      prop: 'agencyId',
      placeholder: '请输入代理商编码',
      search: true,
      type: 'input',
      rules: [
        {
          required: true,
          trigger: 'blur',
          message: '请输入代理商编码'
        }
      ]
    },
    {
      label: '代理商名称',
      prop: 'agencyName',
      placeholder: '请输入代理商名称',
      search: true,
      type: 'input',
      rules: [
        {
          required: true,
          trigger: 'blur',
          message: '请输入代理商名称'
        }
      ]
    },
    {
      label: '接口密钥',
      prop: 'agentSecret',
      type: 'input',
      placeholder: '新增必填；编辑留空则不修改',
      addDisplay: false,
      editDisplay: false
    },
    /* {
      label: '创建人ID',
      prop: 'creator',
      type: 'input',
      hide: true,
      addDisplay: false,
      editDisplay: false
    },
    {
      label: '创建人',
      prop: 'createBy',
      type: 'input',
      addDisplay: false,
      editDisplay: false
    },
    {
      label: '创建时间',
      prop: 'createTime',
      type: 'datetime',
      sortable: true,
      format: 'yyyy-MM-dd HH:mm:ss',
      addDisplay: false,
      editDisplay: false
    },
    {
      label: '更新人',
      prop: 'updateBy',
      type: 'input',
      hide: true,
      addDisplay: false,
      editDisplay: false
    },
    {
      label: '更新时间',
      prop: 'updateTime',
      type: 'datetime',
      format: 'yyyy-MM-dd HH:mm:ss',
      hide: true,
      addDisplay: false,
      editDisplay: false
    },
    {
      label: '删除标识',
      prop: 'deleteFlag',
      type: 'radio',
      hide: true,
      addDisplay: false,
      editDisplay: false,
      dicData: DIC.DELETE_FLAG
    } */
  ]
};